// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"b22008c4","444":"61942d5d"}[chunkId] + ".chunk.js";
};